import AuthSelector_vue_vue_type_script_setup_true_lang_default from "./AuthSelector.vue_vue_type_script_setup_true_lang.js";
//#region src/v2/blocks/scalar-auth-selector-block/components/AuthSelector.vue
var AuthSelector_default = AuthSelector_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { AuthSelector_default as default };

//# sourceMappingURL=AuthSelector.vue.js.map